export default __webpack_public_path__ + "static/media/DanielOrtuzar.85180aaf.png";